module.exports = __webpack_public_path__ + "img/xkzhxyy.02df6791.png";